var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content intelligent-booking" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.HangInTheAir"),
                    name: "tabPending",
                    lazy: true
                  }
                },
                [
                  _c("tab-pending", {
                    ref: "tabPending",
                    attrs: {
                      "active-tab-name": _vm.activeTabName,
                      source: _vm.details.source
                    },
                    on: { showDetails: _vm.handleShowDetails }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  ref: "tabFinished",
                  attrs: {
                    label: _vm.$t("SeaExport.Completed"),
                    name: "tabFinished",
                    lazy: true
                  }
                },
                [
                  _c("tab-finished", {
                    on: { showDetails: _vm.handleShowDetails }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.Dustbin"),
                    name: "tabTrash",
                    lazy: true
                  }
                },
                [_c("tab-trash")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isXhq
        ? _c("intelligent-booking-result-xhq", {
            attrs: {
              visible: _vm.details.visible,
              details: _vm.details.data,
              source: _vm.details.source,
              "jingyu-warehouse": _vm.jingyuWarehouse
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      !_vm.isXhq
        ? _c("intelligent-booking-result", {
            attrs: {
              visible: _vm.details.visible,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }